const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

function buildHeaders(options = {}) {
  const headers = {
    ...(options.headers || {}),
  };

  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
}

async function runApiFetch(path, options = {}, token, onUnauthorized) {
  const headers = buildHeaders(options);

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  const data = await res.json().catch(() => null);

  if (res.status === 401) {
    onUnauthorized?.();
  }

  if (!res.ok) {
    throw new Error(data?.detail || "Request failed");
  }

  return data;
}

export function getToken() {
  return localStorage.getItem("veya_token");
}

export function setToken(token) {
  localStorage.setItem("veya_token", token);
}

export function clearToken() {
  localStorage.removeItem("veya_token");
}

export async function apiFetch(path, options = {}) {
  return runApiFetch(path, options, getToken(), clearToken);
}

export function getShopperToken() {
  return localStorage.getItem("veya_shopper_token");
}

export function setShopperToken(token) {
  localStorage.setItem("veya_shopper_token", token);
}

export function clearShopperToken() {
  localStorage.removeItem("veya_shopper_token");
}

export async function apiFetchShopper(path, options = {}) {
  return runApiFetch(path, options, getShopperToken(), clearShopperToken);
}

export function getVeyaTeamToken() {
  return localStorage.getItem("veya_team_token");
}

export function setVeyaTeamToken(token) {
  localStorage.setItem("veya_team_token", token);
}

export function clearVeyaTeamToken() {
  localStorage.removeItem("veya_team_token");
}

export async function apiFetchVeyaTeam(path, options = {}) {
  return runApiFetch(path, options, getVeyaTeamToken(), clearVeyaTeamToken);
}